import { AlertCircle, CheckCircle2, Circle, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ApproveAlertStep, ApproveAlertStepId } from '../hooks/useApproveAlertProgressSteps';

interface ApproveAlertProgressStepsProps {
  steps: ApproveAlertStep[];
}

function StepIcon({ status }: { status: ApproveAlertStep['status'] }) {
  if (status === 'running') {
    return <Loader2 className="h-5 w-5 shrink-0 animate-spin text-stocker-primary" />;
  }
  if (status === 'done') {
    return <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-600" />;
  }
  if (status === 'error') {
    return <AlertCircle className="h-5 w-5 shrink-0 text-red-600" />;
  }
  return <Circle className="h-5 w-5 shrink-0 text-gray-300" />;
}

export function ApproveAlertProgressSteps({ steps }: ApproveAlertProgressStepsProps) {
  const { t } = useTranslation();

  const stepLabel = (id: ApproveAlertStepId) =>
    t(`forecastReview.alerts.approveModal.steps.${id}`);

  return (
    <ul className="space-y-3">
      {steps.map((step) => (
        <li key={step.id} className="flex items-start gap-3">
          <StepIcon status={step.status} />
          <p
            className={`text-sm font-medium ${
              step.status === 'error' ? 'text-red-700' : 'text-gray-900'
            }`}
          >
            {stepLabel(step.id)}
          </p>
        </li>
      ))}
    </ul>
  );
}
